@if (vaultNav(); as nav) {
  @if (nav.vaults.length > 1) {
    <bit-nav-item
      class="tw-mb-2"
      [text]="'allItems' | i18n"
      [route]="allItemsRoute"
      [routerLinkActiveOptions]="allItemsActiveOptions"
    >
      <bit-icon-tile icon="bwi-list" variant="brand" emphasis="bold" size="sm" />
    </bit-nav-item>
  }

  <ng-template #vaultGroups>
    @for (vault of nav.vaults; track vault.id) {
      @if (vault.type === VaultNavItemType.Personal) {
        <bit-nav-item [text]="vault.label" [route]="vaultRoute(vault)">
          @let personalTile = tile(vault);
          <bit-icon-tile
            [icon]="personalTile.icon"
            [variant]="personalTile.variant ?? 'primary'"
            [color]="personalTile.color"
            [emphasis]="personalTile.emphasis ?? 'subtle'"
            size="sm"
          />
        </bit-nav-item>
      } @else {
        <bit-nav-group [text]="vault.label" [open]="nav.organizationDataOwnership">
          @let vaultTile = tile(vault);
          <bit-icon-tile
            [icon]="vaultTile.icon"
            [variant]="vaultTile.variant ?? 'primary'"
            [color]="vaultTile.color"
            [emphasis]="vaultTile.emphasis ?? 'subtle'"
            size="sm"
          />
          <bit-nav-item
            icon="bwi-list-alt"
            [text]="'allVaultItems' | i18n"
            [route]="vaultRoute(vault)"
          ></bit-nav-item>
        </bit-nav-group>
      }
    }
  </ng-template>

  @if (personalOnly()) {
    @let loneVault = nav.vaults[0];
    <!-- A lone vault still routes to /vault; only the label differs. -->
    <bit-nav-item
      [text]="loneVault.label"
      [route]="allItemsRoute"
      [routerLinkActiveOptions]="allItemsActiveOptions"
    >
      @let loneTile = tile(loneVault);
      <bit-icon-tile
        [icon]="loneTile.icon"
        [variant]="loneTile.variant ?? 'primary'"
        [color]="loneTile.color"
        [emphasis]="loneTile.emphasis ?? 'subtle'"
        size="sm"
      />
    </bit-nav-item>
  } @else if (nav.organizationDataOwnership) {
    <ng-container [ngTemplateOutlet]="vaultGroups"></ng-container>
  } @else if (nav.vaults.length > 1) {
    <bit-nav-section [label]="'vaults' | i18n">
      <ng-container [ngTemplateOutlet]="vaultGroups"></ng-container>
    </bit-nav-section>
  }
}
